module.exports = __webpack_public_path__ + "media/lacto-small.8ff5f746.mp4";